import { render, staticRenderFns } from "./YougovFooter.vue?vue&type=template&id=7243f882&scoped=true&"
import script from "./YougovFooter.vue?vue&type=script&lang=js&"
export * from "./YougovFooter.vue?vue&type=script&lang=js&"
import style0 from "./YougovFooter.vue?vue&type=style&index=0&id=7243f882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7243f882",
  null
  
)

export default component.exports